import { render, staticRenderFns } from "./customer-name.vue?vue&type=template&id=0fdc4468&"
import script from "./customer-name.ts?vue&type=script&lang=js&"
export * from "./customer-name.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports